import React from "react";
import { Button } from "reactstrap";

const Table = ({ data = [], permissions, onEdit, setApiCall }) => {
    const canEdit = true;
    const canDelete = true;

    const onDelete = async (id) => {
        // call your delete endpoint here, then refresh:
        // const res = await Network.delete(`${Urls.deleteOfficeLocation}/${id}`)
        setApiCall((p) => !p);
    };

    return (
        <div className="table-responsive">
            <table className="table align-middle">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Weekly hours</th>
                    {(canEdit || canDelete) && <th className="text-end">Actions</th>}
                </tr>
                </thead>

                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan={3} className="text-center text-muted py-4">
                            No office locations found.
                        </td>
                    </tr>
                ) : (
                    data.map((row) => (
                        <tr key={row.id}>
                            <td>{row.name}</td>
                            <td>{row.weekly_hours ?? "-"}</td>

                            {(canEdit || canDelete) && (
                                <td className="text-end">
                                    {canEdit && (
                                        <Button
                                            size="sm"
                                            color="warning"
                                            className="me-2"
                                            onClick={() => onEdit?.(row)}   // ✅ opens modal
                                        >
                                            Edit
                                        </Button>
                                    )}
                                </td>
                            )}
                        </tr>
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
